import o from "./normalizeArguments.js";
import m from "./parsePhoneNumber_.js";
function u() {
  var t = o(arguments),
    e = t.text,
    r = t.options,
    a = t.metadata;
  return m(e, r, a);
}
export { u as default };